<template>
  <div>
    <b-list-group class="qgl_panel">
      <b-list-group-item
        variant="success"
        button
        :key="item.id"
        v-for="(item, idx) in questions"
        @click="view(item)"
      >
        {{ idx + 1 }}번 문항
        <b-button
          variant="danger"
          class="float-right"
          size="sm"
          @click.stop.passive="del(item)"
          >D</b-button
        >
      </b-list-group-item>
    </b-list-group>
    <b-row>
      <b-col>
        <b-form-group>
          <b-button variant="primary" block size="sm" @click="appendQ">
            문항추가(+)
          </b-button>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  computed: {
    questions() {
      return this.$store.state.qforms;
    },
  },
  methods: {
    view(item) {
      this.$store.dispatch("loadQuestionByID", item.id);
    },
    del(item) {
      if (confirm("삭제하시겠습니까?")) {
        this.$store.dispatch("removeQuestionByID", item.id);
      }
    },
    appendQ() {
      this.$store.commit("resetQuestionForm");
    },
  },
};
</script>


<style lang="scss" scoped>
.qgl_panel {
  margin-bottom: 15px;
}
</style>